import { render, staticRenderFns } from "./game-type.vue?vue&type=template&id=3c9652eb&scoped=true"
import script from "./game-type.vue?vue&type=script&lang=ts"
export * from "./game-type.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9652eb",
  null
  
)

export default component.exports